import React from 'react';

// material ui
import { makeStyles } from '@material-ui/core/styles';
import { Card, CardContent, Grid } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

// styles
import { Theme } from 'assets/types';

export default function ClassroomLinkSkeleton() {
  const classes = useStyles();

  return (
    <>
      {Array.from({ length: 2 }).map((_, index) => (
        <Grid item xs={6} key={index}>
          <Card className={classes.container}>
            <Skeleton variant='rect' className={classes.image}></Skeleton>
            <CardContent className={classes.cardContent}>
              <Skeleton variant='rect' className={classes.content}></Skeleton>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </>
  );
}

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    padding: '20px',
    backgroundColor: theme.palette.grey[100],
  },
  image: {
    width: '100%',
    height: 250,
    objectFit: 'cover',
    backgroundColor: theme.palette.background.paper,
  },
  content: {
    height: 380,
    backgroundColor: theme.palette.grey[400],
  },
  cardContent: {
    '&.MuiCardContent-root': {
      padding: 0,
      paddingTop: 20,
    },
  },
}));
